// Central configuration for backend/API URLs.
// Set REACT_APP_API_URL (and optionally REACT_APP_PAYMENT_URL) at build time.
// Keeping these in one place avoids scattering hardcoded URLs across the app.

const DEFAULT_BACKEND = "https://travel-website-m1kn.onrender.com";

export const API_URL = process.env.REACT_APP_API_URL || DEFAULT_BACKEND;

export const PAYMENT_URL =
  process.env.REACT_APP_PAYMENT_URL ||
  process.env.REACT_APP_API_URL ||
  DEFAULT_BACKEND;
